import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {bankLog, } = api

/**
 * 回传
 */
export async function saveBankLog(params) {
    return request({url: bankLog, method: 'post', data: params,})
}






// WEBPACK FOOTER //
// ./src/services/banklog.js